<template>
  <section class="grid-percent h-100">
    <div
      class="product-item"
      :class="{ empty: !!!item }"
      v-for="(item, index) in tiles"
      :key="index"
    >
      <div class="layer-image-wrapper" v-if="item">
        <b-img
          :src="item.featured_image"
          class="img-fluid w-100 d-block layer-image"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    outfit: Object,
  },

  data() {
    return {
      innerwear: null,
      midwear: null,
      outerwear: null,
      tiles: {
        firstItem: null,
        secondItem: null,
        thirdItem: null,
        bottoms: null,
        footwear: null,
        accessories1: null,
        accessories2: null,
      },
    };
  },

  mounted() {
    this.innerwear = this.findItem("innerwear");
    this.midwear = this.findItem("midwear");
    this.outerwear = this.findItem("outerwear");

    this.tiles.firstItem = this.findFirstItem();
    this.tiles.secondItem = this.findSecondItem();
    this.tiles.thirdItem = this.findThirdItem();
    this.tiles.bottoms = this.findItem("bottoms");
    this.tiles.footwear = this.findItem("footwear");
    this.tiles.accessories1 = this.findItem("accessories1");
    this.tiles.accessories2 = this.findItem("accessories2");
  },

  computed: {
    ...mapGetters(["currentCapsule"]),
  },

  methods: {
    findItem(layerSlug) {
      return this.outfit.products.find((el) => el.layer_slug == layerSlug);
    },

    findFirstItem() {
      if (this.innerwear) {
        return this.innerwear;
      } else if (this.midwear) {
        return this.midwear;
      } else if (this.outerwear) {
        return this.outerwear;
      }
    },

    findSecondItem() {
      if (this.outerwear && (this.innerwear || this.midwear)) {
        return this.outerwear;
      } else if (!!!this.outerwear && this.innerwear && this.midwear) {
        return this.midwear;
      } else {
        return null;
      }
    },

    findThirdItem() {
      return this.innerwear && this.outerwear && this.midwear
        ? this.midwear
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

section {
  display: grid;
  grid-template-columns: 35% 35% 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr;
}

$units: (
  px: 8px,
  rem: 0.5rem,
  percent: 3%,
  fr: 1,
  ch: 1ch,
  ex: 1ex,
  em: 0.5em,
  cm: 1cm,
  mm: 3mm,
  in: 0.125in,
  pt: 10pt,
  pc: 1pc,
  vh: 2vh,
  vw: 0.65vw,
  vmin: 1vmin,
  vmax: 1vmax,
);

@each $unitname, $unitvalue in $units {
  .grid-#{$unitname} {
    gap: #{$unitvalue};
  }
}

div {
  &:first-of-type {
    // grid-column-start: 2;
    // grid-column-end: 3;
    // grid-column is short-hand for the above two properties
    grid-column: 2 / 3;

    // grid-row-start: 1;
    // grid-row-end: 4;
    // grid-row is short-hand for the above two properties
    grid-row: 1 / 4;
  }

  &:nth-of-type(2) {
    grid-column: 1 / 2;
    grid-row: 1 / 4;
  }

  &:nth-of-type(3) {
    grid-column: 1 / 2;
    grid-row: 4 / 7;
  }

  &:nth-of-type(4) {
    grid-column: 2 / 3;
    grid-row: 4 / 7;
  }

  &:nth-of-type(5) {
    grid-column: 3 / 4;
    grid-row: 5 / 7;
  }

  &:nth-of-type(6) {
    grid-column: 3 / 4;
    grid-row: 3 / 5;
  }

  &:nth-of-type(7) {
    grid-column: 3 / 4;
    grid-row: 1 / 3;
  }
}

.layer-content-wrapper {
  background: white;
  border-radius: 0.3em !important;
  border: 1px solid #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  height: 100%;
  padding: 5px;
  text-align: center;

  @include for-tablet-portrait-up {
    padding: 10px;
  }
}

.product-item {
  background: white;
  border-radius: 0.3em !important;
  border: 1px solid $grey5;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  height: 100%;
  padding: 5px;
  text-align: center;

  &.empty {
    background-color: transparent;
    box-shadow: none;
    border-color: transparent;
  }

  @include for-tablet-portrait-up {
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/outfits/BoxLayoutListItem.vue